import {
    SET_LANG,
    SET_WINDOW_SIZES,
} from '../actions/actionTypes';

const initialState = {
    lang: localStorage.getItem('lang') || 'arm',
};

const reducer = (state = initialState, { type, payload }) => {
    switch(type) {
        case SET_LANG:
            return {
                ...state,
                lang: payload,
            };
        case SET_WINDOW_SIZES:
            return {
                ...state,
                width: payload.width,
                height: payload.height,
            };
        default:
            return state;
    }
};

export default reducer;